import { ServiceCollapsibleSection } from "./ServiceCollapsibleSection";
import { ServiceJobTypesEditor } from "./ServiceJobTypesEditor";
import { useServiceWorkQueuesPanel } from "./useServiceWorkQueuesPanel";

export function ServiceJobTypesAdvancedSection(props: { navTick: number; onChanged?: () => void }) {
  const m = useServiceWorkQueuesPanel(props.navTick);

  return (
    <ServiceCollapsibleSection
      title="Job types"
      subtitle="Board lanes — warranty vs repair vs internal prep"
      defaultOpen={false}
    >
      <p className="mb-4 text-sm text-gray-600 dark:text-zinc-400">
        Job types control where work lands on the board — warranty vs paid repair vs internal prep.
        Most orgs use the defaults. Per-service defaults are set under each service&apos;s Basics
        section.
      </p>
      <ServiceJobTypesEditor m={m} onSaved={props.onChanged} />
    </ServiceCollapsibleSection>
  );
}
